import { useQuery } from '@tanstack/react-query';
import type { EventoOS } from '@/types/ordemServico';
import { useOrganization } from '@/hooks/useOrganization';
import { listEventosOS } from '@/services/eventos.service';

export function useEventosOS(ordemServicoId: string | undefined) {
  const { organizationId } = useOrganization();

  return useQuery<EventoOS[]>({
    queryKey: ['eventos-os', organizationId, ordemServicoId],
    queryFn: () => (ordemServicoId ? listEventosOS(ordemServicoId) : Promise.resolve([])),
    enabled: !!ordemServicoId,
  });
}
